import React from 'react';

/**
 * Assets
 */

 import './styles/_index.scss'

/**
 * Components
 */

import { MarkerIcon } from '@components/icon/icon';

const Marker = ({ text }) => {
  
  const handleClick = (e) => {
    const marker = e.target.closest('.marker');
    document.querySelectorAll('.marker').forEach(item => {
      if(item !== marker) {
        item.classList.remove('active');
      }
    })
    marker.classList.toggle('active');
  }
  return (
    <div className="marker" onClick={handleClick} onKeyDown={handleClick} role="presentation">
      <MarkerIcon />
  
      <div className="info-box">
        {text}
      </div>
    </div>
  )
}

export default Marker;
